export default __webpack_public_path__ + "static/twitch-c93d688265fe1ba4f73d60a5c2f90710.svg";